import * as actionType from "../../constants";
import * as commonData from "../../Common";

export const getAllWorkflowUser = (inputs) => async (dispatch) => {
  const url = commonData.commonData().apiUrl;
  try {
    const response = await fetch(`${url}getAllSubUser`, {
      method: "post",
      body: JSON.stringify({ app_token: inputs }),
    });

    const rdata = await response.json();
    if (rdata.code === 200) {
      dispatch({ type: actionType.GET_ALL_WORKFLOW_USER, payload: rdata.data });
    }
  } catch (error) {
    console.log(error.message);
  }
};
